import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { useAlertStore } from '..';

const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;

export const useAdminCountryStore = defineStore('admin-country', {
  state: () => ({
    countries: [],
  }),
  actions: {
    async loadCountries() {
      const alertStore = useAlertStore();
      try {
        const res = await fetchWrapper.get(`${baseUrl}/admin/location/load`);
        this.countries = res.locations || [];
      } catch (error) {
        alertStore.error(error);
      }
    },
    async createCountry(data) {
      const alertStore = useAlertStore();
      try {
        await fetchWrapper.post(`${baseUrl}/admin/location/create`, data);
        alertStore.success('New country successfully added');
      } catch (error) {
        alertStore.error(error);
      }
    },
    async updateCountry(data) {
      const alertStore = useAlertStore();
      try {
        await fetchWrapper.post(`${baseUrl}/admin/location/update`, data);
        alertStore.success('Update successful');
      } catch (error) {
        alertStore.error(error);
      }
    },
    async deleteCountries(ids) {
      const alertStore = useAlertStore();
      try {
        await fetchWrapper.post(`${baseUrl}/admin/location/delete`, { ids });
        alertStore.success('Delete successful');
      } catch (error) {
        alertStore.error(error);
      }
    },
  },
});

